import React, { useState, useEffect } from "react";

export default function RoleModal({
  role,
  roleCardImage,
  onClose,
  playSoundQueue,
}) {
  const [flipCount, setFlipCount] = useState(0);
  const [isAnimating, setIsAnimating] = useState(false);

  useEffect(() => {
    const timer = setTimeout(() => {
      setIsAnimating(true);
    }, 10);
    return () => clearTimeout(timer);
  }, []);

  const handleCardFlip = () => {
    // เช็กก่อนว่าฟังก์ชัน playSoundQueue ถูกส่งมาหรือไม่เพื่อป้องกัน Error
    if (playSoundQueue) {
      playSoundQueue({ sounds: "card_flip", category: "ui" });
    }
    setFlipCount((currentCount) => currentCount + 1);
  };

  const handleClose = () => {
    setIsAnimating(false);
    setTimeout(onClose, 300);
  };

  return (
    <div
      className="fixed inset-0 bg-black bg-opacity-80 flex items-center justify-center z-50 p-4 transition-opacity duration-300"
      onClick={handleClose}
    >
      <div
        className={`w-full max-w-sm flex flex-col items-center gap-4 transition-all duration-300 ease-out ${
          isAnimating ? "scale-100 opacity-100" : "scale-50 opacity-0"
        }`}
        onClick={(e) => e.stopPropagation()}
      >
        <div className="w-full [perspective:1000px]">
          <div
            className="relative w-full aspect-[2.5/3.5] transition-transform duration-700 ease-in-out [transform-style:preserve-3d]"
            onClick={handleCardFlip}
            style={{ transform: `rotateY(${flipCount * 180}deg)` }}
          >
            <div className="absolute w-full h-full [backface-visibility:hidden]">
              <img
                src={roleCardImage}
                alt={`Role: ${role}`}
                className="w-full h-full object-contain cursor-pointer"
              />
            </div>
            <div className="absolute w-full h-full [backface-visibility:hidden] [transform:rotateY(180deg)]">
              <img
                src="/images/role_cards/card_back.png"
                alt="Card Back"
                className="w-full h-full object-contain cursor-pointer"
              />
            </div>
          </div>
        </div>
        <p className="text-sm text-gray-400 mt-2">
          (คลิกที่การ์ดเพื่อพลิก / คลิกพื้นที่ว่างเพื่อปิด)
        </p>
      </div>
    </div>
  );
}
